
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Payment } from '@accounting/interfaces/payment';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { invoiceDisplayFields, paymentDisplayFields } from '@/config/invoices';
import { Invoice } from '@accounting/interfaces/invoice';
import moment from 'moment/moment';

@Component({
  name: 'bpc-invoice-summary-card',
  components: {
    'bpc-display-field-badge': DisplayFieldBadge,
  },
})
export default class InvoiceSummaryCard extends Vue {
  // PROPS
  @Prop({
    type: [Object, Array],
    default() {
      return [];
    },
  })
  @Prop(Object)
  readonly invoice: Invoice;
  @Prop({ type: Boolean }) readonly showPayments;

  // DATA
  paymentItems: Payment[] = [];

  // LIFECYCLE
  mounted() {
    this.paymentItems = this.invoice.payments;
  }

  //COMPUTED
  get invoiceDisplayConfig() {
    return invoiceDisplayFields;
  }

  get paymentDisplayConfig() {
    return paymentDisplayFields;
  }

  get invoiceText(): string {
    return 'global.invoice_type.' + this.invoice.invoice_type;
  }

  formatAmount(value: number) {
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
  }
}
